import { useState } from 'react';
import { UNTITLED_FORM } from '../new-form';
import { TextInput } from 'framework/form';

export const TitleInput = ({ title, onTitle }: { title: string; onTitle: (text: string) => void }) => {
  const [text, setText] = useState<string | null>(null);
  return (
    <div
      onFocus={event => {
        if (event.target instanceof HTMLInputElement) {
          setText(title);
          event.target.select();
        }
      }}
    >
      <TextInput
        source="title"
        label="Title"
        placeholder={UNTITLED_FORM}
        value={text ?? title}
        onChangeCallback={({ title: nextTitle }) => {
          setText(nextTitle);
          onTitle(nextTitle);
        }}
        validationCallback={() => setText(null)}
      />
    </div>
  );
};
